// Minimal geo-based locale detection (IP lookup only).
//
// This runs in the BACKGROUND after first paint (see Root in main.tsx) — it
// must never block rendering. The old navigator.geolocation path was removed
// deliberately: it popped a browser permission prompt on a visitor's very
// first load (hostile UX) and added up to 2s before the IP fallback even
// started. IP-level country detection is all the language guess needs.
// Replace the endpoint with your own service in production and handle
// privacy/consent.

const COUNTRY_TO_LOCALE: Record<string, 'en' | 'ne' | 'hi'> = {
  NP: 'ne',
  IN: 'hi',
  // add more if you support them later
}

function mapCountryToLocale(countryCode?: string): 'en' | 'ne' | 'hi' {
  if (!countryCode) return 'en'
  const up = countryCode.toUpperCase()
  return COUNTRY_TO_LOCALE[up] ?? 'en'
}

async function withTimeout<T>(p: Promise<T>, ms = 2500): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const id = setTimeout(() => reject(new Error('timeout')), ms)
    p.then(v => { clearTimeout(id); resolve(v) })
     .catch(e => { clearTimeout(id); reject(e) })
  })
}

async function detectByIP(): Promise<'en' | 'ne' | 'hi'> {
  // Example public endpoint; swap for your backend or a paid service.
  // ipapi.co returns { country: "NP", ... }
  const res = await withTimeout(fetch('https://ipapi.co/json/'))
  const json = await res.json().catch(() => ({} as any))
  return mapCountryToLocale(json?.country)
}

export async function detectDefaultLocaleFromGeo(): Promise<'en' | 'ne' | 'hi'> {
  try {
    return await detectByIP()
  } catch {
    return 'en'
  }
}
